import React, { useContext, useState, useEffect } from "react";
import { TranslatorContext } from "../../context/Translator";
import { Link } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import { EcommerceCardComponent, SalesCardComponent, ProductsCardComponent, RevenueCardComponent, ClientsCardComponent, ActivityCardComponent, OrdersCardComponent } from "../../components/cards";
import PageLayout from "../../layouts/PageLayout";
import heros from "../../assets/data/heros.json";
import {getDataDashboard} from "../../api/mantenedores.ts";
import { useAuthStore } from "../../store/auth.store.ts";




export default function EcommercePage() {

    const { t, n } = useContext(TranslatorContext);
    const { usuario } = useAuthStore((state) => state);
    
    const [data, setData] = useState([]);   
    const [ingresos, setIngresos] = useState([]);
    const [ingresosmensuales, setIngresosmensuales] = useState([]);
    const [pagosrealizados, setPagosrealizados] = useState([]);
    
     useEffect(() => {
        getDataDashboard()
            .then((response) => {
                setData(response.data);
                setIngresos(response.ingresos);
                setIngresosmensuales(response.ingresomensual);
                setPagosrealizados(response.pagosrealizados);
            })
            .catch((error) => {
                console.error("Error fetching data:", error);
            });
    }
    , []);
    return (
        <PageLayout>
            <Row>
                <Col xl={12}>
                    <div className="mc-card">
                        <div className='mc-breadcrumb'>
                            <h3 className="mc-breadcrumb-title">Dashboard</h3>
                            <ul className="mc-breadcrumb-list">
                                <li className="mc-breadcrumb-item"><Link to='#' className="mc-breadcrumb-link">{t('home')}</Link></li>
                                <li className="mc-breadcrumb-item">Dashboard</li>
                            </ul>
                        </div>
                    </div>
                </Col>
                <Col xs={12} xl={8}>
                    <Row xs={1} sm={2}>
                        {data.map((hero, index) => (
                            <Col key={index}>
                                <EcommerceCardComponent
                                    icon={hero.icon}
                                    trend={hero.trend}
                                    title={t(hero.title)}
                                    variant={hero.variant}
                                    number={n(hero.number)}
                                    percent={hero.percent} 
                                />
                            </Col>
                        ))}
                    </Row>
                </Col>

                {usuario?.roles?.[0]?.codigo === "MASTER" && (
                    <>
                        <Col xs={12} xl={4}> <SalesCardComponent ingresos={ingresos} ingresosmensuales={ingresosmensuales}  /> </Col>
                       
                      
                        <Col xl={4}> <OrdersCardComponent pagosrealizados={pagosrealizados} /> </Col>
                    </>
                )}
            </Row>
        </PageLayout>
    );
}
